export default () => {
  const i18n = useI18n();
  const currencyStore = useCurrencyStore();

  const dateTimeFormat = computed(() => {
    const options: Intl.DateTimeFormatOptions = {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    };

    if (i18n.locale.value === 'en') {
      const currency = currencyStore.currency;
      if (currency === 'USD') {
        return new Intl.DateTimeFormat('en-us', options);
      }

      return new Intl.DateTimeFormat('en-gb', options);
    }

    return new Intl.DateTimeFormat(i18n.locale.value, options);
  });

  const formatFn = (date: string | Date | number | bigint) => {
    if (typeof date === 'bigint') {
      date = Number(date);
    }

    let d = null;
    if (typeof date === 'string' || typeof date === 'number') {
      d = new Date(date);
    } else {
      d = date;
    }

    return dateTimeFormat.value.format(d);
  };

  return {
    formatFn,
    dateTimeFormat,
  };
};
